import React, { useMemo } from 'react';
import { StyledTag, SummaryColumnHeader, SummaryWrapper } from './styled';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { Card, Col, Radio, Row, Statistic, Tag } from 'antd';

const Summary = ({ data }) => {
  const count = useMemo(
    () =>
      data.reduce(
        (acc, config) => ({
          total: acc.total + 1,
          disabled: config.state === 1 ? acc.disabled + 1 : acc.disabled,
          enabled: config.state === 2 ? acc.enabled + 1 : acc.enabled,
        }),
        {
          total: 0,
          enabled: 0,
          disabled: 0,
        },
      ),
    [data],
  );

  return (
    <SummaryWrapper>
      {Object.keys(count).map((key) => (
        <StyledTag key={key}>
          <SummaryColumnHeader>{key}</SummaryColumnHeader>
          <h2>{count[key]}</h2>
        </StyledTag>
      ))}
    </SummaryWrapper>
  );
};

export default Summary;
